import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const allowed = this.authService.sessionData.pipe(
            map((data) => {
                if (data.isLoggedIn && data.user.expires > Date.now()) {
                    return true;
                }

                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                this.authService.expired();
                return false;
            })
        );

        return allowed;
    }
}
